import React from 'react';

const NoMatch = () => <div>This Page does not exist.</div>;

export default NoMatch;
